module.exports = __webpack_public_path__ + "img/grs.041fa3da.svg";